import type { AssetTypePageHeaderProps } from "./asset-type-page-header.type";

import BaseHeader from "@/components/Header/BaseHeader";
import AssetTypeDeleteButton from "@/modules/asset-type/asset-type-delete-button";
import AssetTypeEditButton from "@/modules/asset-type/asset-type-edit-button";

const AssetTypePageHeader = ({
  assetType,
  loading,
}: AssetTypePageHeaderProps) => {
  return (
    <BaseHeader
      title={assetType?.name}
      loading={loading}
      extra={
        assetType ? (
          <>
            <AssetTypeEditButton assetType={assetType} />
            <AssetTypeDeleteButton assetType={assetType} hideDanger />
          </>
        ) : undefined
      }
    />
  );
};

export default AssetTypePageHeader;
